<!-- The modal is created per opening instead of only being toggled, because the design system renders the modal's
     content in an overlay which does not project the content again once it has been closed. -->
@if (profileVisible()) {
  <ds-modal #profileModal
            [ds-modal-trigger-for]="profileModal"
            [isModalOpen]="true"
            [isDismissable]="true"
            [dimensionsConfig]="DIMENSIONS"
            (modalDismiss)="handleCloseProfile()"
            id="customer-data-profile-dialog"
            size="lg"
            [nonScrollable]="true">
    <ds-box-content class="customer-data-profile-content">
      <customer-data-profile
        [attr.account-number]="accountNumber()"
        [attr.lang]="locale()"
        [attr.auth-info]="authInfoJson()"
        [attr.base-url]="baseUrl"
        [attr.business-partner-id]="businessPartnerId()"
        show-back-button
        enable-vehicle-selection
        (closeProfile)="handleCloseProfile()"
        (selectVehicle)="handleSelectVehicle($event)">
      </customer-data-profile>
    </ds-box-content>
  </ds-modal>
}
